export default function WishlistSummary({ count, totalValue }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <div className="rounded-3xl border border-border bg-white p-6 shadow-lg shadow-black/5">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
          Total Items
        </p>
        <p className="mt-2 text-3xl font-black">{count}</p>
      </div>

      <div className="rounded-3xl border border-border bg-white p-6 shadow-lg shadow-black/5">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
          Wishlist Value
        </p>
        <p className="mt-2 text-3xl font-black">
          BDT {totalValue.toLocaleString()}
        </p>
      </div>

      <div className="rounded-3xl border border-border bg-white p-6 shadow-lg shadow-black/5">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
          Status
        </p>
        <p className="mt-2 text-3xl font-black">Guest Ready</p>
      </div>
    </div>
  );
}